(function() {
    'use strict';

    angular
        .module('app.layout')
        .directive('hqHead', hqHead);

    /* @ngInject */
    function hqHead() {
        var directive = {
            bindToController: true,
            templateUrl: 'hq-head.tpl',
            controller: hqHeadCtrl,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
                data: '='
            }
        };
        return directive;

        function link(scope, element, attrs) {
            scope.vm.total = scope.vm.data.seller_data.hq.stats.total;
            scope.vm.price = scope.vm.data.seller_data.hq.stats.pie_price;
            scope.vm.sold = scope.vm.data.seller_data.hq.stats.sold;
            scope.vm.progress = Math.round(scope.vm.sold / scope.vm.data.seller_data.hq.goal.value * 100);
            scope.vm.towards = 100 - scope.vm.progress;
            // scope.vm.days2go = scope.vm.data.seller_data.hq.stats.days2go;
            scope.vm.days2go = scope.$root.globals.site_options.shopping_cart_settings.days2go;
            // console.log(['hq-head', scope.vm.data]);
        }

    }

    /* @ngInject */
    function hqHeadCtrl($scope, $http) {
        $scope.saving = false;
        $scope.save = function(what) {
            var params = {
                hq: {
                    goal: {
                        value: what == 'team' ?  $scope.vm.data.team.goal : $scope.vm.data.seller_data.hq.goal.value
                    }
                }
            };
            if (what == 'team') {
                params.team_id = $scope.vm.data.team.id;
            }

            $scope.doSave('save_' + what + '_data', params);
        };
        $scope.doSave = function(method, data) {
            if (!$scope.saving) {
                $scope.saving = true;
                $http.post(ajaxurl, {
                    action: 'pie_action',
                    method: method,
                    nonce: $scope.$root.stats.nonce,
                    params: data
                }).then(function(response) {
                    $scope.saving = false;
                    if ($scope.vm.data.team.years) {
                        $scope.vm.data.team.years[0].sales.forEach(function(e) {
                            if (e.seller_name.toLowerCase().indexOf('team') === 0) {
                                if (e.goal) {
                                    e.goal = $scope.vm.data.team.goal;
                                }
                            }
                        });
                    }
                });
            }
        };

    }

})();